export const createAdditionalItem = (index = 0) => ({
  id: `additional-${Date.now()}-${index}`,
  name: '',
  price: 0,
});

export const createDefaultAdditionalItems = () => [createAdditionalItem(1)];

export const withDefaultAdditionalItems = (config) => ({
  ...config,
  additionalItems: createDefaultAdditionalItems(),
});

export const getFilledAdditionalItems = (items = []) =>
  items.filter((item) => {
    const name = (item?.name || '').trim();
    const price = Number(item?.price) || 0;
    return name || price !== 0;
  });

export const sumAdditionalItemsPrice = (items = []) =>
  getFilledAdditionalItems(items).reduce((sum, item) => sum + (Number(item.price) || 0), 0);

/** Parse a price that may add (+) or subtract (−) from the quote total. */
export const parseAdditionalItemPrice = (raw) => {
  const normalized = String(raw ?? '')
    .trim()
    .replace(/\u2212/g, '-') // unicode minus
    .replace(/\s/g, '')
    .replace(',', '.');
  if (normalized === '' || normalized === '-' || normalized === '+') return 0;
  const parsed = parseFloat(normalized);
  return Number.isNaN(parsed) ? 0 : parsed;
};

export const applyAdditionalItemsChange = (prev, updater) => ({
  ...prev,
  additionalItems:
    typeof updater === 'function'
      ? updater(prev.additionalItems || createDefaultAdditionalItems())
      : updater,
});

/** Quote-level extras on Offerte Exporteren — price is incl. BTW (matches investment table). */
export const getQuoteExtraLineItems = (clientDetails) =>
  (clientDetails?.extraLineItems || []).filter((item) => {
    const name = (item?.name || '').trim();
    const price = Number(item?.price) || 0;
    return name && price !== 0;
  });

export const sumQuoteExtraLineItemsInclVat = (clientDetails) =>
  getQuoteExtraLineItems(clientDetails).reduce(
    (sum, item) => sum + (Number(item.price) || 0),
    0,
  );
